<template>
  <div class="elevation-2">
    <v-toolbar color="primary" dark tabs>
      <v-tabs
        v-model="tabs"
        fixed-tabs
        color="transparent"
        slider-color="white"
      >
        <v-tab href="#tab-1">Utilities</v-tab>
        <v-tab href="#tab-2">Vendors</v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="tabs">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text class="pa-4 body-1 blue-grey--text text--darken-3">
            <utilities></utilities>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <v-card-text class="pa-4 body-1 blue-grey--text text--darken-3">
            <vendors></vendors>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Vendors from './ResourceVendor';
import Utilities from './ResourceUtilities';

export default {
  name: 'TheResourcesTabs',
  components: {
    Vendors,
    Utilities,
  },
  data() {
    return {
      tabs: null,
    };
  },
};
</script>
